import { prop } from 'ramda';
import { IRealtyValuation } from '../../types/realtyValuation';

export const getLastUpdateDate = (realtyValuation: IRealtyValuation): string => {
  return prop('lastUpdateDate', realtyValuation);
};
